export default __webpack_public_path__ + "static/media/soviets.2bbab489.jpg";